import { all, call, put, select } from 'redux-saga/effects';

import { getTrackingEvents } from '../../../api/orderTrackerApi';
import { fetchTrackingEventsSucceed, setCachedDataToStore, setOrderStatusFromTrackingEvents } from '../../actions';
import { TrackingEventsService } from '../services/trackingEventsService';

export function* trackingEventsRequest({
  orderMilestones,
  deliveriesToTrack,
}: Pick<common.DeliveryDetailData, 'deliveriesToTrack' | 'orderMilestones'>) {
  const {
    caching: { cachedTrackingEventResponses = [], cachedTrackingId },
  } = yield select((state) => state);

  let trackingReferenceItemsToRequest;
  if (cachedTrackingId) {
    trackingReferenceItemsToRequest = deliveriesToTrack.filter(({ orderId }) => orderId !== cachedTrackingId);
  } else {
    trackingReferenceItemsToRequest = deliveriesToTrack;
  }

  try {
    let trackingResponses: common.DeliveryTrackingInfo[] = [];
    if (trackingReferenceItemsToRequest.length) {
      const trackingApiCalls = trackingReferenceItemsToRequest.map((trackingData) =>
        call(getTrackingEvents, trackingData),
      );
      trackingResponses = yield all(trackingApiCalls);
    }
    if (!cachedTrackingEventResponses.length && trackingReferenceItemsToRequest.length) {
      const [{ orderId }] = trackingReferenceItemsToRequest;

      yield put(
        setCachedDataToStore({
          cachedTrackingId: orderId,
          cachedTrackingEventResponses: trackingResponses || null,
        }),
      );
    } else {
      trackingResponses.push(...cachedTrackingEventResponses);
    }

    const { getOrderStatusFromTrackingEvents, mapDeliveryMilestoneItems, isTrackingEventsFailed } =
      new TrackingEventsService(trackingResponses);

    yield put(setOrderStatusFromTrackingEvents({ orderStatusFromTrackingEvents: getOrderStatusFromTrackingEvents() }));
    yield put(
      fetchTrackingEventsSucceed({
        orderMilestones: mapDeliveryMilestoneItems(orderMilestones),
        isTrackingEventsFailed,
      }),
    );
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    console.error('Tracking Events Request:', message);
  }
}
